import { sv } from "@dhx/ts-common/dom";
import { ISeria, IStacker, PointData } from "../types";


export default class Stacker implements IStacker {
	private _series : ISeria[] = [];
	private _toPaint : ISeria[];

	add(seria) {
		this._series.push(seria);
	}
	dataReady(prev?: PointData[]): PointData[]{
		this._toPaint = this._series.filter(serie => {
			const next = serie.dataReady(prev);
			if (next.length){
				prev = next;
				return true;
			}
			return false;
		});
		return prev || [];
	}
	getPoints(){
		if (this._toPaint.length){
			return this._toPaint[0].getPoints().concat(this._toPaint[this._toPaint.length-1].getPoints());
		}
		return [];
	}
	paint(width:number, height:number, prev?:PointData[]) {
		const svg = [];
		const markers = [];
		this._toPaint.forEach(seria => {
			if (seria.paintformAndMarkers) {
				const [content, seriesMarkers] = seria.paintformAndMarkers(width, height, prev);
				svg.push(content);
				markers.push(seriesMarkers);
			} else {
				const content = seria.paint(width, height, prev);
				svg.push(content);
			}
			prev = seria.getPoints();
		});

		return sv("g", svg.concat(markers));
	}
}